<div id="enrollment-merchant-account-wrapper" [formGroup]="accountForm" data-cy="enrollment-account-form">
  <app-merchant-contact-form style="width: 100%" formGroupName="Contact"></app-merchant-contact-form>
  <app-merchant-business-form style="width: 100%" formGroupName="Business"></app-merchant-business-form>
</div>
